// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"styles_imageContainer__9lXVs","wishlistButton":"styles_wishlistButton__CGcpA","breadcrumbContainer":"styles_breadcrumbContainer__O_J_m"};